/* @formschema/native v2.0.0-beta.1 (c) Sébastien Demanou - MIT */
function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}
const UniqueId$1 = {
    get(prefix = '', delimiter = '-') {
        const suffix = s4() + s4();
        return prefix ? prefix + delimiter + suffix : suffix;
    },
    parse(str) {
        return `${str}`.toLowerCase().replace(/\s+/g, '-');
    }
};

const Objects$1 = {
    isObject(value) {
        return Objects$1.isGenericObject(value) && !Array.isArray(value);
    },
    isGenericObject(value) {
        return value !== null && typeof value === 'object';
    },
    equal(x, y) {
        if (x === y) {
            return true;
        }
        if ((typeof x === 'object' && x != null) && (typeof y === 'object' && y !== null)) {
            if (Object.keys(x).length !== Object.keys(y).length) {
                return false;
            }
            for (const prop in x) {
                if (y.hasOwnProperty(prop)) {
                    if (!Objects$1.equal(x[prop], y[prop])) {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
            return true;
        }
        return false;
    },
    assign(dest, src) {
        Object.keys(src).forEach((key) => {
            const value = src[key];
            if (!Objects$1.isObject(value) || typeof value === 'function') {
                dest[key] = value;
            }
            else if (value instanceof Array) {
                dest[key] = [...value];
            }
            else {
                if (!dest[key]) {
                    dest[key] = {};
                }
                Objects$1.assign(dest[key], value);
            }
        });
        return dest;
    },
    clone(value) {
        if (Objects$1.isObject(value)) {
            const object = value instanceof Array ? [] : {};
            return Objects$1.assign(object, value);
        }
        return value;
    },
    isEmpty(object) {
        for (const key in object) {
            return false;
        }
        return true;
    },
    clear(object) {
        for (const key in object) {
            delete object[key];
        }
    }
};

class Components$1 {
    constructor() {
        this.$ = {
            form: 'form',
            message: 'div',
            default: 'input'
        };
    }
    set(kind, component) {
        this.$[kind] = component;
    }
    get(kind, fallbackComponent = this.$.default) {
        return this.$[kind] || fallbackComponent;
    }
}

const Fieldset$1 = {
    renderChildren(h, field, children = field.children) {
        return children
            .filter((childField) => childField.descriptor.visible)
            .map((childField) => h(childField.descriptor.component, {
            key: childField.key,
            attrs: childField.descriptor.attrs,
            props: {
                field: childField
            }
        }));
    },
    renderGroups(h, field) {
        return field.descriptor.childrenGroups.map(({ id, label, children }) => {
            const childrenNodes = Fieldset$1.renderChildren(h, field, children);
            const nodes = [
                h('div', {
                    attrs: {
                        'data-fs-group-nodes': childrenNodes.length
                    }
                }, childrenNodes)
            ];
            if (label) {
                nodes.unshift(h('div', {
                    attrs: {
                        'data-fs-group-label': id
                    }
                }, label));
            }
            return h('div', {
                attrs: {
                    'data-fs-group': id
                }
            }, nodes);
        });
    }
};

const Value = {
    parseValue(data, { type }) {
        if (this.hasOwnProperty(type)) {
            if (type === 'boolean' && typeof data === 'string') {
                data = data === 'true';
            }
            return Value[type](data);
        }
        return data;
    },
    null() {
        return null;
    },
    boolean(value) {
        return value === true;
    },
    integer(data) {
        const value = Number(data);
        const parsedValue = Number.parseInt(data, 10);
        return Number.isNaN(value) || Number.isNaN(parsedValue) ? undefined : parsedValue;
    },
    number(data) {
        const value = Number(data);
        const parsedValue = Number.parseFloat(data);
        return Number.isNaN(value) || Number.isNaN(parsedValue) ? undefined : parsedValue;
    },
    object(data) {
        return data || {};
    },
    string(data) {
        return typeof data !== 'undefined' ? `${data}` : undefined;
    },
    array(data) {
        return data instanceof Array
            ? data.filter((item) => typeof item !== 'undefined')
            : [];
    }
};

const CreateInput = (h, tag, data, children = [], event = 'input') => {
    const props = data.props;
    return h(tag, {
        key: props.field.key,
        attrs: props.field.descriptor.attrs,
        on: {
            [event]({ target }) {
                props.field.setValue(target.value);
            }
        }
    }, children);
};

const Field = {
    renderMessages(h, field, nodes, renderAtTop = false) {
        field.messages.forEach(({ text, type = 3 }) => {
            const messageNode = h(field.descriptor.components.get('message'), {
                props: { text, type }
            }, text);
            if (renderAtTop) {
                nodes.unshift(messageNode);
            }
            else {
                nodes.push(messageNode);
            }
        });
    }
};

const FieldElement = {
    name: 'FieldElement',
    functional: true,
    render(h, { data, props, children }) {
        const field = props.field;
        const descriptor = props.field.descriptor;
        if (field.kind === 'hidden' || descriptor.definition.kind === 'hidden') {
            return children;
        }
        const type = descriptor.attrs.type || field.kind;
        const attrs = {
            'data-fs-kind': field.kind,
            'data-fs-type': type,
            'data-fs-field': field.name,
            'data-fs-required': field.required,
            'data-fs-horizontal': descriptor.props.horizontal
        };
        const labelElement = h('label', {
            attrs: descriptor.labelAttrs
        }, descriptor.label);
        const fieldElement = h('div', {
            attrs: {
                'data-fs-input': type
            },
            props: { field }
        }, children);
        const nodes = [fieldElement];
        const helperNode = h(descriptor.components.get('helper'), data);
        if (helperNode.tag) {
            nodes.push(helperNode);
        }
        Field.renderMessages(h, field, nodes);
        const wrapperElement = nodes.length === 1
            ? nodes
            : h('div', {
                attrs: {
                    'data-fs-wrapper': nodes.length
                }
            }, nodes);
        return h('div', { attrs }, [labelElement, wrapperElement]);
    }
};

const InputElement = {
    name: 'InputElement',
    functional: true,
    render(h, { data, children }) {
        return h(FieldElement, data, [
            CreateInput(h, 'input', data),
            ...(children || [])
        ]);
    }
};

const StateElement = {
    name: 'StateElement',
    functional: true,
    render(h, { data, props: { field }, children = [] }) {
        return h(FieldElement, data, [
            h('input', {
                key: field.key,
                attrs: field.descriptor.attrs,
                on: {
                    change: ({ target }) => field.setValue(target.checked)
                }
            }),
            ...children
        ]);
    }
};

const FieldsetElement = {
    name: 'FieldsetElement',
    functional: true,
    render(h, { data, props, slots }) {
        const field = props.field;
        const descriptor = props.field.descriptor;
        const nodes = descriptor.kind === 'object' && !Objects$1.isEmpty(descriptor.groups)
            ? Fieldset$1.renderGroups(h, field)
            : slots().default || Fieldset$1.renderChildren(h, field);
        if (descriptor.definition.kind === 'hidden') {
            return nodes;
        }
        if (!field.isRoot) {
            return h(descriptor.definition.layout || FieldElement, data, nodes);
        }
        const attrs = Object.assign(Object.assign({}, descriptor.attrs), (data.attrs || {}));
        const helper = h(descriptor.components.get('helper'), data);
        // avoid rendering of <!-- --> by only confidering defined herper
        if (helper.tag) {
            nodes.unshift(helper);
        }
        if (descriptor.label && descriptor.layout === 'fieldset') {
            const attrs = descriptor.labelAttrs;
            const legend = h('legend', { attrs }, descriptor.label);
            nodes.unshift(legend);
        }
        Field.renderMessages(h, field, nodes, field.isRoot);
        return h(descriptor.layout, { props, attrs }, nodes);
    }
};

const ArrayElement = {
    name: 'ArrayElement',
    functional: true,
    render(h, { data, props }) {
        var _a;
        const ArrayButtonElement = props.field.descriptor.components.get('button');
        const nodes = props.field.children.map((childField) => {
            const childDescriptor = childField.descriptor;
            const buttonsWrapper = [];
            const childData = {
                key: childField.key,
                attrs: childDescriptor.attrs,
                props: { field: childField }
            };
            if (!props.field.uniqueItems && props.field.sortable) {
                if (childDescriptor.buttons.length && (props.field.schema.minItems === 0 || props.field.value.length > 1)) {
                    const buttons = childDescriptor.buttons;
                    const buttonsNodes = buttons.map((button) => h(button.component || ArrayButtonElement, {
                        props: { button, field: childField }
                    }));
                    buttonsWrapper.push(h('div', {
                        key: props.field.key + childField.key,
                        attrs: {
                            'data-fs-buttons': buttonsNodes.length
                        }
                    }, buttonsNodes));
                }
            }
            if (childDescriptor.kind === 'object') {
                const componentNode = h(FieldsetElement, childData);
                const fieldsetData = {
                    props: {
                        // TODO this sounds deprecated. The field object no longer has a helper property
                        field: Object.assign(Object.assign({}, childField), { helper: {} }) // remove the duplicate bottom helper
                    }
                };
                return h(FieldElement, fieldsetData, [componentNode, buttonsWrapper]);
            }
            return h(childDescriptor.component, childData, buttonsWrapper);
        });
        if (!props.field.uniqueItems && props.field.children.length < props.field.maxItems) {
            if (props.field.pushButton) {
                if (((_a = props.field.descriptor.definition.pushButton) === null || _a === void 0 ? void 0 : _a.visible) !== false) {
                    nodes.push(h(props.field.descriptor.pushButton.component || ArrayButtonElement, {
                        props: {
                            button: props.field.descriptor.pushButton,
                            field: props.field
                        }
                    }));
                }
            }
        }
        return h(FieldsetElement, data, nodes);
    }
};

const ListElement = {
    name: 'ListElement',
    functional: true,
    render(h, { data, props }) {
        const descriptor = props.field.descriptor;
        const children = descriptor.options.map(({ label, value, selected }) => {
            return h('option', { attrs: { value, selected } }, label);
        });
        return h(FieldElement, data, [
            CreateInput(h, 'select', data, children, 'change')
        ]);
    }
};

const TextareaElement = {
    name: 'TextareaElement',
    functional: true,
    render(h, { data, props, children }) {
        return h(FieldElement, data, [
            CreateInput(h, 'textarea', data, props.field.value),
            ...(children || [])
        ]);
    }
};

const MessageElement = {
    functional: true,
    name: 'MessageElement',
    render(h, { props }) {
        return h('div', {
            attrs: {
                'data-fs-message': props.type
            }
        }, [
            h('span', {
                attrs: {
                    'data-fs-message-text': true
                }
            }, props.text)
        ]);
    }
};

const ArrayButtonElement = {
    functional: true,
    name: 'ArrayButtonElement',
    render(h, { props: { button } }) {
        return h('button', {
            attrs: {
                type: 'button',
                title: button.tooltip,
                disabled: button.disabled,
                'data-fs-button': button.type
            },
            on: {
                click: button.trigger
            }
        }, button.label);
    }
};

const HelperElement = {
    name: 'HelperElement',
    functional: true,
    render(h, { props }) {
        const field = props.field;
        const descriptor = props.field.descriptor;
        if (descriptor.helper) {
            const tag = field.isRoot ? 'p' : 'span';
            const data = {
                attrs: Object.assign(Object.assign({}, descriptor.helperAttrs), { 'data-fs-helper': true })
            };
            return h(tag, data, descriptor.helper);
        }
        return null; // render nothing
    }
};

class NativeComponents$1 extends Components$1 {
    constructor() {
        super();
        this.set('array', ArrayElement);
        this.set('boolean', StateElement);
        this.set('string', InputElement);
        this.set('password', InputElement);
        this.set('file', InputElement);
        this.set('image', InputElement);
        this.set('radio', StateElement);
        this.set('checkbox', StateElement);
        this.set('enum', FieldsetElement);
        this.set('number', InputElement);
        this.set('integer', InputElement);
        this.set('object', FieldsetElement);
        this.set('list', ListElement);
        this.set('textarea', TextareaElement);
        this.set('message', MessageElement);
        this.set('helper', HelperElement);
        this.set('button', ArrayButtonElement);
    }
}

const NativeElements = new NativeComponents$1();

const DESCRIPTORS = {};
class UIDescriptor$1 {
    constructor(definition, field, components) {
        this.visible = typeof definition.visible === 'boolean' ? definition.visible : true;
        this.kind = field.kind;
        this.attrs = Object.assign(Object.assign({}, field.attrs), (definition.attrs || {}));
        this.props = definition.props || {};
        this.components = components || NativeElements;
        this.component = definition.component || this.components.get(this.kind) || NativeElements.get(this.kind);
        this.schema = field.schema;
        this.definition = definition;
        this.label = definition.hasOwnProperty('label')
            ? definition.label || ''
            : field.schema.title || '';
        this.helper = definition.hasOwnProperty('helper')
            ? definition.helper || ''
            : field.schema.description || '';
        this.labelAttrs = {
            id: this.label ? `${this.attrs.id}-label` : undefined,
            for: this.attrs.id
        };
        this.helperAttrs = {
            id: this.helper ? `${this.attrs.id}-helper` : undefined
        };
        /**
         * Use the WAI-ARIA aria-labelledby and aria-describedby attributes to
         * associate instructions with form controls
         * @see https://www.w3.org/WAI/tutorials/forms/instructions/#providing-instructions-outside-labels
         */
        this.attrs['aria-labelledby'] = this.labelAttrs.id;
        this.attrs['aria-describedby'] = this.helperAttrs.id;
    }
    static register(kind, parserClass) {
        DESCRIPTORS[kind] = parserClass;
    }
    static get(options, field, components) {
        if (!DESCRIPTORS.hasOwnProperty(field.kind)) {
            throw new TypeError(`Unknow descriptor kind '${field.kind}'`);
        }
        if (typeof options === 'function') {
            options = options(field);
        }
        return new DESCRIPTORS[field.kind](options, field, components);
    }
    parse(field) {
        // Make sure descriptor.attrs is sync with field.attrs
        Object.assign(this.attrs, field.attrs, this.definition.attrs || {});
    }
    // eslint-disable-next-line
    update(field) {
        // do nothing by default, inherited class will override this if needed
    }
}

const PARSERS = {};
class Parser$1 {
    constructor(kind, options, parent) {
        this.id = options.id || UniqueId$1.get(options.name);
        this.parent = parent;
        this.options = options;
        this.isRoot = !parent;
        this.schema = Objects$1.clone(options.schema);
        this.kind = kind;
        this.rawValue = this.parseValue(this.initialValue);
        this.model = this.parseValue(this.initialValue);
        const self = this;
        this.field = {
            id: this.id,
            key: UniqueId$1.get(this.options.id),
            kind: this.kind,
            name: this.options.name,
            isRoot: this.isRoot,
            schema: this.options.schema,
            required: this.options.required || false,
            deep: this.parent ? this.parent.field.deep + 1 : 0,
            attrs: {
                id: this.id,
                type: undefined,
                name: this.options.name,
                readonly: this.schema.readOnly,
                get required() {
                    return self.field.required;
                },
                /**
                 * Add support with web browsers that don’t communicate the required
                 * attribute to assistive technology
                 * @see https://www.w3.org/WAI/tutorials/forms/validation/#validating-required-input
                 */
                get 'aria-required'() {
                    return this.required ? 'true' : undefined;
                }
            },
            get value() {
                return self.model;
            },
            setValue: (value, emitChange = true) => {
                this.setValue(value);
                if (emitChange) {
                    this.commit();
                }
            },
            commit: () => this.commit(),
            hasChildren: false,
            initialValue: this.initialValue,
            reset: () => {
                this.reset();
                this.commit();
            },
            clear: () => {
                this.clear();
                this.commit();
            },
            parent: this.parent ? this.parent.field : undefined,
            get root() {
                return self.root.field;
            },
            messages: [],
            requestRender: () => this.requestRender(),
            addMessage(text, type = 3) {
                this.messages.push({ text, type });
            },
            clearMessages() {
                this.messages.splice(0);
            }
        };
    }
    static register(kind, parserClass) {
        PARSERS[kind] = parserClass;
    }
    static kind(schema) {
        return schema.enum
            ? schema.enum.length > 4 ? 'list' : 'enum'
            : schema.type;
    }
    static get(options, parent) {
        if (typeof options.schema.type === 'undefined') {
            return null;
        }
        if (!PARSERS[options.schema.type]) {
            throw TypeError(`Unsupported schema type: ${JSON.stringify(options.schema.type)}`);
        }
        const kind = options.descriptor && options.descriptor.kind
            ? options.descriptor.kind
            : options.kind;
        const parserKind = kind && PARSERS.hasOwnProperty(kind)
            ? kind
            : Parser$1.kind(options.schema);
        if (kind) {
            options.kind = kind;
        }
        const parser = new PARSERS[parserKind](options, parent);
        parser.parse();
        return parser;
    }
    get root() {
        return this.parent ? this.parent.root : this;
    }
    get initialValue() {
        return typeof this.options.model === 'undefined'
            ? this.schema.const || this.schema.default
            : this.options.model;
    }
    isEmpty(data = this.model) {
        return typeof data === 'undefined';
    }
    parseValue(data) {
        return Value.parseValue(data, this.schema);
    }
    setValue(value) {
        this.rawValue = value;
        this.model = this.parseValue(value);
    }
    reset() {
        this.setValue(this.parseValue(this.initialValue));
    }
    clear() {
        this.setValue(this.parseValue(undefined));
    }
    commit() {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.model, this.field);
        }
    }
    requestRender(fields) {
        if (typeof this.root.options.requestRender === 'function') {
            if (!fields) {
                this.field.key = UniqueId$1.get(this.options.name);
                fields = [this.field];
            }
            this.field.descriptor.update(this.field);
            this.root.options.requestRender(fields);
        }
    }
    parseDescriptor() {
        this.field.descriptor = UIDescriptor$1.get(this.options.descriptor || {}, this.field, this.options.components);
        this.field.descriptor.parse(this.field);
    }
    parse() {
        this.parseField();
        this.parseDescriptor();
        this.commit();
    }
}

const RE_ARRAY_PATH = /(.+)?\[(\d+)\]$/;
function getFieldByIndex(field, index) {
    const parsedIndex = Number.parseInt(index, 10);
    const indexField = field.children[parsedIndex];
    return indexField || null;
}
class SetParser extends Parser$1 {
    constructor(kind, options, parent) {
        super(kind, options, parent);
        this.field.hasChildren = true;
        this.field.clearMessages = (recursive = false) => {
            this.field.messages.splice(0);
            if (recursive) {
                this.field.children.forEach((child) => child.clearMessages(true));
            }
        };
        this.field.getField = (path) => {
            const formatedPath = path[0] === '.' ? path.substring(1) : path;
            if (!formatedPath) {
                return this.field;
            }
            const paths = formatedPath.split('.');
            let fields = this.field.fields;
            let foundField = null;
            for (let currentPath of paths) {
                const match = RE_ARRAY_PATH.exec(currentPath);
                if (match) {
                    if (match[1]) {
                        currentPath = match[1];
                    }
                    else {
                        // case path === '[index]'
                        foundField = foundField || this.field;
                        return getFieldByIndex(foundField, match[2]);
                    }
                }
                for (const key in fields) {
                    if (key === currentPath) {
                        foundField = fields[key];
                        if (match) {
                            foundField = getFieldByIndex(foundField, match[2]);
                        }
                        if (foundField && foundField.hasChildren) {
                            fields = foundField.fields;
                            break;
                        }
                        return foundField;
                    }
                }
            }
            return foundField;
        };
    }
}

const Arrays = {
    index(items, item) {
        return items.findIndex((currentItem) => currentItem === item);
    },
    swap(items, from, to) {
        [items[from], items[to]] = [items[to], items[from]];
        return items[to];
    },
    remove(items, item) {
        const index = this.index(items, item);
        if (index > -1) {
            return items.splice(index, 1).pop();
        }
        return undefined;
    }
};

class ArrayParser extends SetParser {
    constructor(options, parent) {
        super('array', options, parent);
        this.items = [];
        this.max = -1;
        this.count = 0;
        this.radioIndex = 0;
        this.childrenParsers = [];
    }
    get initialValue() {
        const value = this.options.model || this.schema.default;
        return value instanceof Array ? [...value] : [];
    }
    get limit() {
        if (this.field.uniqueItems || this.items.length === 0) {
            return this.items.length;
        }
        if (this.count < this.field.minItems || !Array.isArray(this.schema.items)) {
            return this.count;
        }
        return this.count < this.items.length
            ? this.count
            : this.items.length;
    }
    get children() {
        const limit = this.limit;
        const fields = Array(...Array(limit))
            .map((x, index) => this.getFieldIndex(index))
            .filter((field) => field !== null);
        if (limit < this.count && this.additionalItems) {
            let index = limit;
            do {
                const additionalField = this.getFieldItem(this.additionalItems, index);
                if (additionalField === null) {
                    break;
                }
                fields.push(additionalField);
            } while (++index < this.count);
        }
        return fields;
    }
    setFieldValue(field, value) {
        // since it's possible to order children fields, the
        // current field's index must be computed each time
        // TODO: an improvement can be done by using a caching index table
        const index = this.childrenParsers.findIndex((parser) => parser.field === field);
        this.setIndexValue(index, value);
    }
    setIndexValue(index, value) {
        this.rawValue[index] = value;
        this.setValue(this.rawValue);
    }
    isEmpty(data = this.model) {
        return data instanceof Array && data.length === 0;
    }
    clearModel() {
        for (let i = 0; i < this.rawValue.length; i++) {
            this.rawValue[i] = undefined;
        }
        this.model.splice(0);
    }
    setValue(value) {
        this.rawValue = value;
        this.model.splice(0);
        this.model.push(...this.parseValue(this.rawValue));
    }
    reset() {
        this.clearModel();
        this.initialValue.forEach((value, index) => this.setIndexValue(index, value));
        this.childrenParsers.forEach((parser) => parser.reset());
    }
    clear() {
        this.clearModel();
        this.childrenParsers.forEach((parser) => parser.clear());
    }
    getFieldItemName(name, index) {
        return this.root.options.bracketedObjectInputName ? `${name}[${index}]` : name;
    }
    getFieldItem(itemSchema, index) {
        const kind = this.field.uniqueItems
            ? 'boolean'
            : SetParser.kind(itemSchema);
        const itemModel = typeof this.model[index] === 'undefined'
            ? itemSchema.default
            : this.model[index];
        const itemDescriptor = this.options.descriptor && this.options.descriptor.items
            ? this.options.descriptor.items instanceof Array
                ? this.options.descriptor.items[index]
                : this.options.descriptor.items
            : { kind };
        const itemName = this.options.name || itemModel;
        const name = kind === 'enum' && this.radioIndex++
            ? `${itemName}-${this.radioIndex}`
            : itemName;
        const itemParser = SetParser.get({
            kind: kind,
            schema: itemSchema,
            model: itemModel,
            id: `${this.id}-${index}`,
            name: this.getFieldItemName(name, index),
            descriptor: itemDescriptor,
            components: this.root.options.components
        }, this);
        if (this.rawValue.length <= index) {
            this.rawValue.push(undefined);
        }
        if (itemParser) {
            this.childrenParsers.push(itemParser);
            if (kind === 'boolean') {
                this.parseCheckboxField(itemParser, itemModel);
            }
            // update the index raw value
            this.rawValue[index] = itemParser.model;
            // set the onChange option after the parser initialization
            // to prevent first field value emit
            itemParser.options.onChange = this.field.sortable
                ? (value) => {
                    this.setFieldValue(itemParser.field, value);
                    this.commit();
                }
                : (value) => {
                    this.setIndexValue(index, value);
                    this.commit();
                };
            return itemParser.field;
        }
        return null;
    }
    getFieldIndex(index) {
        const itemSchema = this.schema.items instanceof Array || this.field.uniqueItems
            ? this.items[index]
            : this.items[0];
        return this.getFieldItem(itemSchema, index);
    }
    move(from, to) {
        const items = this.field.children;
        if (items[from] && items[to]) {
            const movedField = Arrays.swap(items, from, to);
            Arrays.swap(this.rawValue, from, to);
            this.field.setValue(this.rawValue);
            this.parse();
            return movedField;
        }
        return undefined;
    }
    isDisabled([from, to]) {
        return !this.field.sortable || !this.field.children[from] || !this.field.children[to];
    }
    upIndexes(itemField) {
        const from = Arrays.index(this.field.children, itemField);
        const to = from - 1;
        return [from, to];
    }
    downIndexes(itemField) {
        const from = Arrays.index(this.field.children, itemField);
        const to = from + 1;
        return [from, to];
    }
    setButtons(itemField) {
        itemField.buttons = {
            moveUp: {
                disabled: this.isDisabled(this.upIndexes(itemField)),
                trigger: () => this.move(...this.upIndexes(itemField))
            },
            moveDown: {
                disabled: this.isDisabled(this.downIndexes(itemField)),
                trigger: () => this.move(...this.downIndexes(itemField))
            },
            delete: {
                disabled: !this.field.sortable,
                trigger: () => {
                    const index = Arrays.index(this.field.children, itemField);
                    const deletedField = this.field.children.splice(index, 1).pop();
                    if (deletedField) {
                        this.rawValue.splice(index, 1);
                        this.field.setValue(this.rawValue);
                        this.count--;
                        this.requestRender();
                    }
                    return deletedField;
                }
            }
        };
    }
    setCount(value) {
        if (this.schema.maxItems && value > this.field.maxItems) {
            return false;
        }
        this.count = value;
        this.radioIndex = 0;
        this.childrenParsers.splice(0);
        this.field.fields = {};
        this.field.children = this.children;
        this.field.children.forEach((item, i) => {
            this.field.fields[i] = item;
        });
        // apply array's model
        this.setValue(this.rawValue);
        this.field.children.forEach((itemField) => this.setButtons(itemField));
        return true;
    }
    parseField() {
        this.field.sortable = false;
        this.field.minItems = this.schema.minItems || (this.field.required ? 1 : 0);
        this.field.maxItems = typeof this.schema.maxItems === 'number' && this.schema.maxItems > 0
            ? this.schema.maxItems
            : Number.MAX_SAFE_INTEGER;
        if (this.schema.items) {
            if (this.schema.items instanceof Array) {
                this.items.push(...this.schema.items);
                if (this.schema.additionalItems && !Objects$1.isEmpty(this.schema.additionalItems)) {
                    this.additionalItems = this.schema.additionalItems;
                }
            }
            else {
                this.items.push(this.schema.items);
                this.field.sortable = true;
            }
        }
        const self = this;
        const resetField = this.field.reset;
        this.field.pushButton = {
            get disabled() {
                return self.count === self.max || self.items.length === 0;
            },
            trigger: () => this.setCount(this.count + 1) && this.requestRender()
        };
        this.count = this.field.minItems > this.model.length
            ? this.field.minItems
            : this.model.length;
        // force render update for ArrayField
        this.field.addItemValue = (itemValue) => {
            if (this.field.pushButton.disabled) {
                return false;
            }
            this.rawValue.push(itemValue);
            this.setValue(this.rawValue);
            this.field.pushButton.trigger();
            return true;
        };
        // force render update for ArrayField
        this.field.reset = () => {
            resetField.call(this.field);
            this.requestRender();
        };
        this.parseUniqueItems();
        this.setCount(this.count);
    }
    parseCheckboxField(parser, itemModel) {
        const isChecked = this.initialValue.includes(itemModel);
        parser.field.attrs.type = 'checkbox';
        parser.setValue = (checked) => {
            parser.rawValue = checked;
            parser.model = checked ? itemModel : undefined;
        };
        parser.setValue(isChecked);
    }
    parseUniqueItems() {
        if (this.schema.uniqueItems === true && this.items.length === 1) {
            const itemSchema = this.items[0];
            if (itemSchema.enum instanceof Array) {
                this.field.uniqueItems = true;
                this.field.maxItems = itemSchema.enum.length;
                this.count = this.field.maxItems;
                this.items.splice(0);
                itemSchema.enum.forEach((value) => this.items.push(Object.assign(Object.assign({}, itemSchema), { enum: undefined, default: value, title: `${value}` })));
                this.max = this.items.length;
            }
            else {
                this.max = this.schema.maxItems || this.items.length;
            }
        }
        else if (this.schema.maxItems) {
            this.max = this.field.maxItems;
        }
        else if (this.schema.items instanceof Array) {
            this.max = this.additionalItems ? -1 : this.items.length;
        }
        else {
            this.max = -2;
        }
        if (this.field.uniqueItems) {
            const values = [];
            this.items.forEach((itemSchema) => {
                if (this.model.includes(itemSchema.default)) {
                    values.push(itemSchema.default);
                }
                else {
                    values.push(undefined);
                }
            });
            this.model.splice(0);
            this.model.push(...values);
        }
    }
    parseValue(data) {
        return Value.array(data);
    }
}
SetParser.register('array', ArrayParser);

const Pattern = {
    /**
     * Escape a pattern for a Regex
     * @param str String to escape
     * @returns boolean The excaped string
     * @see https://stackoverflow.com/a/6969486
     */
    escape(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
};

class ScalarParser extends Parser$1 {
    static getKind(schema, parent) {
        if (parent && parent.schema.enum instanceof Array) {
            return 'radio';
        }
        return null;
    }
    static getType(kind) {
        switch (kind) {
            case 'radio':
            case 'hidden':
                return kind;
            default:
                return null;
        }
    }
    constructor(kind, type, options, parent) {
        super(kind, options, parent);
        if (type) {
            this.field.attrs.type = type;
            this.field.attrs.value = this.model;
        }
    }
    parseField() {
        this.field.hasChildren = false;
        if (this.schema.const) {
            this.field.attrs.pattern = Pattern.escape(`${this.schema.const}`);
        }
    }
}

class BooleanParser extends ScalarParser {
    constructor(options, parent) {
        const schema = options.schema;
        const kind = options.kind || ScalarParser.getKind(schema, parent) || 'boolean';
        const type = ScalarParser.getType(kind) || 'checkbox';
        super(kind, type, options, parent);
    }
    isEmpty(data = this.model) {
        return typeof data !== 'boolean';
    }
    parseField() {
        super.parseField();
        if (this.field.attrs.type !== 'radio') {
            Object.defineProperty(this.field.attrs, 'checked', {
                enumerable: true,
                get: () => !!this.model
            });
        }
        this.field.toggle = () => {
            this.field.setValue(!this.model);
        };
    }
    parseValue(checked) {
        return Value.boolean(checked);
    }
}
Parser$1.register('boolean', BooleanParser);

class EnumParser extends SetParser {
    constructor(options, parent) {
        super('enum', options, parent);
        this.childrenParsers = [];
    }
    get fields() {
        if (!Array.isArray(this.schema.enum)) {
            return {};
        }
        const radioId = this.options.id || UniqueId$1.get();
        const radioName = this.options.name || UniqueId$1.get();
        const descriptorItems = this.options.descriptor && this.options.descriptor.items
            ? this.options.descriptor.items
            : {};
        this.childrenParsers.splice(0);
        return this.schema.enum
            .map((item) => (Object.assign(Object.assign({}, this.schema), { default: item, const: undefined, enum: undefined, description: undefined, title: `${item}` })))
            .reduce((fields, itemSchema) => {
            const item = itemSchema.default;
            const parser = Parser$1.get({
                id: `${radioId}-${UniqueId$1.parse(item)}`,
                name: radioName,
                kind: 'radio',
                schema: itemSchema,
                model: itemSchema.default,
                descriptor: descriptorItems[item],
                components: this.root.options.components
            }, this);
            if (parser) {
                // set the onChange option after the parser initialization
                // to prevent first field value emit
                parser.options.onChange = () => {
                    // In this step the input.checked property is already setted.
                    // So no need to call updateInputsState().
                    // So call the parent function super.setValue() instead of
                    // the overrided one this.setValue()
                    super.setValue(item);
                    this.commit();
                };
                fields[item] = parser.field;
                this.childrenParsers.push(parser);
            }
            return fields;
        }, {});
    }
    setValue(value) {
        super.setValue(value);
        this.updateInputsState();
    }
    reset() {
        super.reset();
        this.childrenParsers.forEach((parser) => parser.reset());
    }
    clear() {
        super.clear();
        this.childrenParsers.forEach((parser) => parser.clear());
    }
    updateInputsState() {
        for (const itemField of this.field.children) {
            itemField.attrs.checked = itemField.value === this.model;
            if (itemField.attrs.checked) {
                itemField.descriptor.attrs.checked = 'checked';
            }
        }
    }
    parseField() {
        this.field.fields = this.fields;
        this.field.children = Object.values(this.field.fields);
        this.updateInputsState();
    }
}
SetParser.register('enum', EnumParser);

class NumberParser extends ScalarParser {
    constructor(options, parent) {
        const schema = options.schema;
        const kind = options.kind || ScalarParser.getKind(schema, parent) || schema.type;
        const type = ScalarParser.getType(kind) || 'number';
        super(kind, type, options, parent);
    }
    parseExclusiveKeywords() {
        if (this.schema.hasOwnProperty('exclusiveMinimum')) {
            const exclusiveMinimum = this.schema.exclusiveMinimum;
            this.field.attrs.min = exclusiveMinimum + 0.1;
        }
        if (this.schema.hasOwnProperty('exclusiveMaximum')) {
            const exclusiveMaximum = this.schema.exclusiveMaximum;
            this.field.attrs.max = exclusiveMaximum - 0.1;
        }
    }
    parseField() {
        super.parseField();
        Object.defineProperty(this.field.attrs, 'value', {
            enumerable: true,
            get: () => (this.isEmpty(this.model) ? undefined : `${this.model}`)
        });
        this.field.attrs.min = this.schema.minimum;
        this.field.attrs.max = this.schema.maximum;
        this.field.attrs.step = this.schema.multipleOf;
        this.parseExclusiveKeywords();
    }
    parseValue(data) {
        return Value.number(data);
    }
}
Parser$1.register('number', NumberParser);

class IntegerParser extends NumberParser {
    parseExclusiveKeywords() {
        if (this.schema.hasOwnProperty('exclusiveMinimum')) {
            const exclusiveMinimum = this.schema.exclusiveMinimum;
            this.field.attrs.min = exclusiveMinimum + 1;
        }
        if (this.schema.hasOwnProperty('exclusiveMaximum')) {
            const exclusiveMaximum = this.schema.exclusiveMaximum;
            this.field.attrs.max = exclusiveMaximum - 1;
        }
    }
    parseValue(data) {
        return Value.integer(data);
    }
}
Parser$1.register('integer', IntegerParser);

class ListParser extends Parser$1 {
    constructor(options, parent) {
        super('list', options, parent);
    }
    get items() {
        if (this.schema.enum instanceof Array) {
            return this.schema.enum
                .map((item) => this.parseItem(item))
                .map((item) => ({
                value: item,
                selected: this.model === this.parseValue(item)
            }));
        }
        return [];
    }
    parseItem(item) {
        switch (this.schema.type) {
            case 'boolean':
                return item === true ? 'true' : 'false';
            case 'null':
                return 'null';
            default:
                return item;
        }
    }
    parseField() {
        this.field.hasChildren = false;
        this.field.items = this.items;
    }
}
Parser$1.register('list', ListParser);

class NullParser extends ScalarParser {
    constructor(options, parent) {
        const schema = options.schema;
        const kind = ScalarParser.getKind(schema, parent) || 'hidden';
        const type = ScalarParser.getType(kind) || 'hidden';
        super(kind, type, options, parent);
    }
    parseField() {
        super.parseField();
        this.field.attrs.value = '\u0000';
    }
    parseValue() {
        return null;
    }
}
Parser$1.register('null', NullParser);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

class ObjectParser extends SetParser {
    constructor(options, parent) {
        super('object', options, parent);
        this.properties = {};
        this.dependencies = {};
        this.childrenParsers = {};
        this.initialSchema = Objects$1.clone(this.schema);
    }
    get initialValue() {
        const value = this.options.model || this.schema.default;
        return Objects$1.isObject(value) ? Object.assign({}, value) : {};
    }
    get fields() {
        const name = this.options.name;
        const fields = {};
        const descriptorProperties = this.options.descriptor
            ? this.options.descriptor.properties || {}
            : {};
        const requiredFields = this.schema.required instanceof Array
            ? this.schema.required
            : [];
        Object.keys(this.properties)
            .map((key) => ({
            key,
            options: {
                schema: this.properties[key],
                model: this.model.hasOwnProperty(key) ? this.model[key] : this.properties[key].default,
                id: `${this.id}-${key}`,
                name: this.getChildName(key, name),
                required: requiredFields.includes(key),
                descriptor: descriptorProperties[key],
                components: this.root.options.components,
                onChange: (value) => this.setKeyValue(key, value)
            }
        }))
            .map((_a) => {
            var { options } = _a, args = __rest(_a, ["options"]);
            return (Object.assign(Object.assign({}, args), { parser: Parser$1.get(options, this) }));
        })
            .filter(({ parser }) => parser instanceof Parser$1)
            .forEach(({ key, parser }) => {
            const field = parser.field;
            const update = parser.options.onChange;
            field.property = key;
            this.childrenParsers[key] = parser;
            /**
             * Update the parser.options.onChange reference to
             * enable dependencies update
             */
            parser.options.onChange = (value) => {
                update(value);
                this.commit();
                if (!this.parseConditional()) {
                    this.updateDependencies(key, parser);
                }
            };
            fields[key] = field;
        });
        return fields;
    }
    setKeyValue(key, value) {
        this.rawValue[key] = value;
        this.model[key] = value;
    }
    isEmpty(data = this.model) {
        return Objects$1.isEmpty(data);
    }
    clearModel() {
        Objects$1.clear(this.rawValue);
        Objects$1.clear(this.model);
    }
    reset() {
        this.clearModel();
        for (const key in this.childrenParsers) {
            this.childrenParsers[key].reset();
            this.setKeyValue(key, this.childrenParsers[key].model);
        }
    }
    clear() {
        this.clearModel();
        for (const key in this.childrenParsers) {
            this.childrenParsers[key].clear();
        }
    }
    updateDependencies(key, parser) {
        if (this.dependencies[key]) {
            const needUpdate = [parser.field];
            const isRequired = !parser.isEmpty();
            const fieldRequired = isRequired || this.hasFilledDependency(key);
            this.setRequiredDependency(key, parser, fieldRequired);
            this.dependencies[key].forEach((prop) => {
                const dependencyParser = this.childrenParsers[prop];
                this.setRequiredDependency(prop, dependencyParser, isRequired);
                needUpdate.push(dependencyParser.field);
            });
            this.requestRender(needUpdate);
        }
    }
    hasFilledDependency(key) {
        return Object.keys(this.dependencies).some((prop) => {
            return this.dependencies[prop].includes(key) && !this.childrenParsers[prop].isEmpty();
        });
    }
    setRequiredDependency(key, parser, required) {
        if (parser.isEmpty(this.model[key])) {
            parser.field.key = UniqueId$1.get(key);
        }
        parser.field.required = required;
    }
    getChildName(key, name) {
        if (name) {
            return this.root.options.bracketedObjectInputName
                ? `${name}[${key}]`
                : `${name}.${key}`;
        }
        return key;
    }
    parse() {
        super.parse();
        this.parseConditional();
    }
    parseField() {
        if (this.schema.properties) {
            this.properties = Object.assign({}, this.schema.properties);
        }
        this.parseDependencies();
        this.field.fields = this.fields;
        this.field.children = Object.values(this.field.fields);
        /**
         * attributes `required` and `aria-required` are not applicable here
         */
        delete this.field.attrs.required;
        delete this.field.attrs['aria-required'];
        if (this.isRoot) {
            /**
             * attribute `name` is not applicable here since the
             * parent form element already use it
             */
            delete this.field.attrs.name;
        }
    }
    parseConditional() {
        /* istanbul ignore else */
        if (this.initialSchema.if) {
            const cachedSchema = Objects$1.clone(this.schema);
            this.parseConditionalSchema(this.initialSchema);
            if (Objects$1.equal(cachedSchema, this.schema)) {
                return false;
            }
            this.resetConditionalSchemaProperties(this.schema);
            this.parseField();
            return true;
        }
        return false;
    }
    validateConditionalSchemaValue(conditionalSchema) {
        const properties = conditionalSchema.properties || {};
        for (const prop in properties) {
            if (!properties[prop] || this.model[prop] !== properties[prop].const) {
                return false;
            }
        }
        return true;
    }
    mergeConditionalSchema(conditionalSchema) {
        /* istanbul ignore else */
        if (conditionalSchema.properties) {
            const conditionalProperties = conditionalSchema.properties || {};
            const schemaProperties = this.schema.properties || {};
            const schemaRequired = this.schema.required || [];
            Object.assign(this.schema, conditionalSchema);
            this.schema.properties = schemaProperties;
            this.schema.required = schemaRequired;
            for (const prop in conditionalProperties) {
                const property = conditionalProperties[prop];
                /* istanbul ignore else */
                if (this.schema.properties[prop]) {
                    Object.assign(this.schema.properties[prop], property);
                }
                else {
                    this.schema.properties[prop] = property;
                }
            }
            if (conditionalSchema.required) {
                this.schema.required.push(...conditionalSchema.required);
            }
        }
    }
    resetConditionalSchemaProperties(conditionalSchema) {
        /* istanbul ignore else */
        if (conditionalSchema.properties) {
            const initialSchemaProperties = this.initialSchema.properties || {};
            for (const prop in conditionalSchema.properties) {
                if (initialSchemaProperties[prop]) {
                    continue;
                }
                /* istanbul ignore else */
                if (this.field.fields.hasOwnProperty(prop)) {
                    const property = conditionalSchema.properties[prop];
                    const defaultSchemaValue = property.default;
                    this.field.fields[prop].setValue(defaultSchemaValue, false);
                    this.setKeyValue(prop, defaultSchemaValue);
                }
            }
        }
    }
    parseConditionalSchema(conditionalSchema) {
        /* istanbul ignore else */
        if (conditionalSchema.if) {
            if (this.validateConditionalSchemaValue(conditionalSchema.if)) {
                /* istanbul ignore else */
                if (conditionalSchema.then) {
                    this.mergeConditionalSchema(conditionalSchema.then);
                }
            }
            else if (conditionalSchema.else) {
                if (conditionalSchema.else.if) {
                    this.parseConditionalSchema(conditionalSchema.else);
                }
                else {
                    this.mergeConditionalSchema(conditionalSchema.else);
                }
            }
        }
    }
    parseDependencies() {
        const dependencies = this.schema.dependencies;
        if (dependencies) {
            Object.keys(dependencies).forEach((key) => {
                const dependency = dependencies[key];
                if (dependency instanceof Array) {
                    this.dependencies[key] = dependency;
                }
                else {
                    const properties = dependency.properties || {};
                    this.dependencies[key] = Object.keys(properties);
                    Object.keys(properties).forEach((prop) => {
                        this.properties[prop] = properties[prop];
                    });
                }
            });
        }
    }
    parseValue(data) {
        return Value.object(data);
    }
}
Parser$1.register('object', ObjectParser);

const TypeFormat = {
    date: 'date',
    'date-time': 'datetime-local',
    email: 'email',
    'idn-email': 'email',
    time: 'time',
    uri: 'url'
};
function getKind(schema) {
    if (schema.contentMediaType) {
        const mime = schema.contentMediaType;
        if (mime.startsWith('text/')) {
            return 'textarea';
        }
        if (mime.startsWith('image/')) {
            return 'image';
        }
        return 'file';
    }
    return 'string';
}
function getType(kind, schema) {
    switch (kind) {
        case 'file':
        case 'password':
            return kind;
        case 'image':
            return 'file';
        case 'textarea':
            return undefined;
        default:
            return schema.format
                ? TypeFormat[schema.format]
                : 'text';
    }
}
class StringParser extends ScalarParser {
    constructor(options, parent) {
        const schema = options.schema;
        const kind = options.kind || ScalarParser.getKind(schema, parent) || getKind(schema);
        const type = ScalarParser.getType(kind) || getType(kind, schema);
        super(kind, type, options, parent);
    }
    isEmpty(data = this.model) {
        return typeof data === 'string' ? data.length === 0 : true;
    }
    parseField() {
        super.parseField();
        if (this.field.attrs.type === 'file') {
            this.field.attrs.accept = this.schema.contentMediaType;
        }
        if (this.field.attrs.type) {
            Object.defineProperty(this.field.attrs, 'value', {
                enumerable: true,
                configurable: true,
                get: () => this.model
            });
            if (this.schema.pattern) {
                this.field.attrs.pattern = this.schema.pattern;
            }
        }
        this.field.attrs.minlength = this.schema.minLength;
        this.field.attrs.maxlength = this.schema.maxLength;
    }
    parseValue(data) {
        return Value.string(data);
    }
}
Parser$1.register('string', StringParser);
Parser$1.register('password', StringParser);
Parser$1.register('file', StringParser);
Parser$1.register('image', StringParser);
Parser$1.register('textarea', StringParser);

function parseActionButton(itemField, buttons) {
    return buttons.map((button) => {
        const defaultButton = itemField.buttons[button.type] || {};
        return {
            type: button.type,
            label: button.label || defaultButton.label,
            trigger: button.trigger || defaultButton.trigger,
            tooltip: button.tooltip || defaultButton.tooltip,
            component: button.component || defaultButton.component,
            get disabled() {
                return button.disabled || defaultButton.disabled || false;
            }
        };
    });
}
const BUTTONS = {
    moveUp: {
        type: 'moveUp',
        label: '↑',
        tooltip: undefined
    },
    moveDown: {
        type: 'moveDown',
        label: '↓',
        tooltip: undefined
    },
    delete: {
        type: 'delete',
        label: '-',
        tooltip: undefined
    }
};
class ArrayUIDescriptor extends UIDescriptor$1 {
    constructor(definition, field, components) {
        super(definition, field, components);
        this.items = {};
        this.pushButton = { type: 'push', label: '+' };
        this.buttons = [];
        this.children = [];
        this.layout = definition.layout || 'fieldset';
        this.items = definition.items || {};
    }
    loadButtons(field) {
        field.children.forEach((childField) => {
            if (!field.uniqueItems && field.sortable) {
                const buttons = childField.descriptor.definition.buttons || this.buttons;
                childField.descriptor.buttons = parseActionButton(childField, buttons);
            }
        });
    }
    parseButtons() {
        const buttons = this.definition.buttons || Object.values(BUTTONS);
        for (const button of buttons) {
            this.buttons.push(Object.assign(Object.assign({}, (BUTTONS[button.type] || {})), button));
        }
        console.log(this.buttons)
    }
    parsePushButton(field) {
        if (this.definition.pushButton) {
            Object.assign(this.pushButton, this.definition.pushButton);
        }
        Object.defineProperty(this.pushButton, 'disabled', {
            enumerable: true,
            get: () => field.pushButton.disabled
        });
        if (!this.pushButton.hasOwnProperty('trigger')) {
            this.pushButton.trigger = () => field.pushButton.trigger();
        }
    }
    parse(field) {
        super.parse(field);
        this.parseButtons();
        if (this.definition.pushButton !== null) {
            this.parsePushButton(field);
        }
        this.update(field);
    }
    update(field) {
        this.loadButtons(field);
    }
}
UIDescriptor$1.register('array', ArrayUIDescriptor);

class ItemUIDescriptor extends UIDescriptor$1 {
    constructor(options, field, components) {
        super(options, field, components);
        this.items = options.items || {};
    }
}

const DEFAULT_KIND = 'radio';
class EnumUIDescriptor extends ItemUIDescriptor {
    constructor(options, field, components) {
        super(options, field, components);
        this.children = [];
        this.layout = options.layout || 'fieldset';
    }
    getChildren(field) {
        return field.children.map((childField) => this.getChildDescriptor(childField));
    }
    getChildDescriptor(field) {
        const options = this.items[`${field.value}`] || {};
        if (!options.kind) {
            options.kind = DEFAULT_KIND;
        }
        return UIDescriptor$1.get(options, field, this.components)
            || UIDescriptor$1.get({ kind: DEFAULT_KIND }, field, this.components);
    }
    parse(field) {
        super.parse(field);
        this.children.push(...this.getChildren(field));
    }
}
UIDescriptor$1.register('enum', EnumUIDescriptor);

class ListUIDescriptor extends ItemUIDescriptor {
    constructor() {
        super(...arguments);
        this.options = [];
    }
    getLabel(value) {
        const item = this.items[value];
        return item ? item.label : value;
    }
    getOptions(field) {
        return [
            {
                label: this.props.placeholder,
                value: '',
                selected: false
            },
            ...field.items.map((item) => (Object.assign(Object.assign({}, item), { label: this.getLabel(item.value) })))
        ];
    }
    parse(field) {
        super.parse(field);
        this.options.push(...this.getOptions(field));
    }
}
UIDescriptor$1.register('list', ListUIDescriptor);

class ObjectUIDescriptor extends UIDescriptor$1 {
    constructor(options, field, components) {
        super(options, field, components);
        this.order = [];
        this.orderedProperties = [];
        this.parsedGroups = [];
        this.childrenGroups = [];
        this.layout = options.layout || 'fieldset';
        this.schemaProperties = field.schema.properties || {};
        this.properties = options.properties || {};
        this.groups = options.groups || {};
        if (options.order instanceof Array) {
            this.order.push(...options.order);
        }
    }
    getChildrenGroups(field) {
        const groupsIds = [];
        const ordoredGroups = {};
        if (Objects$1.isEmpty(this.groups)) {
            const groupId = UniqueId$1.get(field.name);
            ordoredGroups[groupId] = this.orderedProperties;
            groupsIds.push(groupId);
        }
        else {
            const reverseGroups = {};
            // setting the reverse groups cache
            for (const groupId in this.groups) {
                this.groups[groupId].properties.forEach((property) => {
                    reverseGroups[property] = groupId;
                });
            }
            // generate groups
            for (let i = 0; i < this.orderedProperties.length; i++) {
                const property = this.orderedProperties[i];
                const groupId = reverseGroups[property] || UniqueId$1.get(field.name);
                if (this.groups[groupId]) {
                    if (!ordoredGroups[groupId]) {
                        groupsIds.push(groupId);
                        ordoredGroups[groupId] = this.groups[groupId].properties;
                    }
                }
                else {
                    let j = i;
                    ordoredGroups[groupId] = [];
                    groupsIds.push(groupId);
                    do {
                        ordoredGroups[groupId].push(this.orderedProperties[j]);
                    } while (++j < this.orderedProperties.length && !reverseGroups[this.orderedProperties[j]]);
                    i = j - 1;
                }
            }
        }
        return groupsIds.map((groupId) => ({
            id: groupId,
            label: this.groups[groupId] ? this.groups[groupId].label : undefined,
            children: ordoredGroups[groupId].map((property) => field.fields[property])
        }));
    }
    parseOrder() {
        if (this.order.length === 0) {
            this.order.push(...Object.keys(this.schemaProperties));
        }
    }
    parseSchemaProperties() {
        const keys = Object.keys(this.schemaProperties);
        this.orderedProperties.push(...this.order);
        if (this.orderedProperties.length < keys.length) {
            keys.forEach((prop) => {
                if (!this.orderedProperties.includes(prop)) {
                    this.orderedProperties.push(prop);
                }
            });
        }
    }
    parseDependencies() {
        const dependencies = this.schema.dependencies;
        if (dependencies) {
            Object.keys(dependencies).forEach((key) => {
                const dependency = dependencies[key];
                if (!Array.isArray(dependency)) {
                    const indexKey = (this.order.indexOf(key) + 1) || this.order.length;
                    const properties = dependency.properties || {};
                    Object.keys(properties).forEach((prop, indexProp) => {
                        if (!this.order.includes(prop)) {
                            // insert dependency after its sibling property
                            // if's there is no custum order defined
                            this.order.splice(indexKey + indexProp, 0, prop);
                        }
                    });
                }
            });
        }
    }
    parse(field) {
        super.parse(field);
        this.parseOrder();
        this.parseDependencies();
        this.parseSchemaProperties();
        this.update(field);
    }
    update(field) {
        this.childrenGroups.splice(0);
        this.childrenGroups.push(...this.getChildrenGroups(field));
    }
}
UIDescriptor$1.register('object', ObjectUIDescriptor);

class ScalarUIDescriptor extends UIDescriptor$1 {
}
UIDescriptor$1.register('string', ScalarUIDescriptor);
UIDescriptor$1.register('password', ScalarUIDescriptor);
UIDescriptor$1.register('number', ScalarUIDescriptor);
UIDescriptor$1.register('integer', ScalarUIDescriptor);
UIDescriptor$1.register('boolean', ScalarUIDescriptor);
UIDescriptor$1.register('null', ScalarUIDescriptor);
UIDescriptor$1.register('hidden', ScalarUIDescriptor);
UIDescriptor$1.register('textarea', ScalarUIDescriptor);
UIDescriptor$1.register('image', ScalarUIDescriptor);
UIDescriptor$1.register('file', ScalarUIDescriptor);
UIDescriptor$1.register('radio', ScalarUIDescriptor);
UIDescriptor$1.register('checkbox', ScalarUIDescriptor);

const GLOBAL = {
    Elements: Object.freeze(NativeElements)
};
const Objects = Objects$1;
const UniqueId = UniqueId$1;
const Components = Components$1;
const Fieldset = Fieldset$1;
const Parser = Parser$1;
const UIDescriptor = UIDescriptor$1;
const NativeComponents = NativeComponents$1;
/**
 * @slot default - Use default slot to insert custom form buttons
 */
const FormSchema = {
    name: 'FormSchema',
    model: {
        prop: 'value',
        event: 'input'
    },
    props: {
        /**
         * The input JSON Schema object.
         */
        schema: {
            type: Object,
            required: true
        },
        /**
         * Use this directive to create two-way data bindings with the
         * component. It automatically picks the correct way to update the
         * element based on the input type.
         *
         * @type any
         */
        value: {
            type: [Number, String, Array, Object, Boolean],
            default: undefined
        },
        /**
         * The id property of the Element interface represents the form's identifier,
         * reflecting the id global attribute.
         *
         * @default Random unique ID
         */
        id: {
            type: String,
            default: UniqueId.get('form')
        },
        /**
         * The name of the form. It must be unique among the forms in a document.
         */
        name: {
            type: String,
            default: undefined
        },
        /**
         * When set to `true` (default), checkbox inputs and nested object inputs
         * will * automatically include brackets at the end of their names
         * (e.g. `name="grouped-checkbox-fields[]"`).
         * Setting this property to `false`, disables this behaviour.
         */
        bracketedObjectInputName: {
            type: Boolean,
            default: true
        },
        /**
         * Use this prop to enable `search` landmark role to identify a section
         * of the page used to search the page, site, or collection of sites.
         */
        search: {
            type: Boolean,
            default: false
        },
        /**
         * Indicates whether the form elements are disabled or not.
         */
        disabled: {
            type: Boolean,
            default: false
        },
        /**
         * Use this prop to overwrite the default Native HTML Elements with
         * custom components.
         *
         * @default GLOBAL.Elements
         */
        components: {
            type: Components,
            default: () => GLOBAL.Elements
        },
        /**
         * UI Schema Descriptor to use for rendering.
         *
         * @type DescriptorInstance
         * @typeref #descriptor-interface
         * @default {}
         */
        descriptor: {
            type: Object,
            default: () => ({})
        },
        /**
         * The validator function to use to validate data before to emit the
         * `input` event.
         *
         * @see [Custom Validation API](#custom-validation-api)
         * @kind function
         * @param {GenericField} field - The field that requests validation
         * @param {string} field.id - The input ID attribute value
         * @param {string} field.name - The input name attribute value
         * @param {any} field.value - The input value for validation
         * @param {JsonSchema} field.schema - The JSON Schema object of the input
         * @param {boolean} field.required - Boolean indicating whether or not the field is mandatory
         * @param {boolean} field.hasChildren - Boolean indicating whether or not the field has children
         * @param {any} field.initialValue - The initial input value
         * @param {Message[]} field.messages - The input value for validation
         * @returns {Promise<boolean>} A promise that return `true` if validation success and `false` otherwise
         */
        validator: {
            type: Function,
            default: null
        }
    },
    data: () => ({
        key: undefined,
        ref: UniqueId.get('formschema'),
        initialModel: undefined,
        ready: false,
        parser: null
    }),
    computed: {
        fieldId() {
            return `${this.id}-field`;
        },
        options() {
            return {
                schema: this.schema,
                model: this.initialModel,
                name: this.name,
                id: this.fieldId,
                required: true,
                descriptor: this.descriptor,
                components: this.components,
                bracketedObjectInputName: this.bracketedObjectInputName,
                onChange: this.emitInputEvent,
                validator: this.validator,
                requestRender: this.update
            };
        },
        listeners() {
            const on = Object.assign({}, this.$listeners);
            on.reset = on.reset ? [on.reset] : [];
            on.reset.unshift(() => {
                if (this.parser) {
                    this.parser.field.reset();
                }
            });
            if (on.submit) {
                const onsubmit = on.submit;
                on.submit = (event) => {
                    if (this.parser) {
                        event.field = this.parser.field;
                    }
                    return onsubmit(event);
                };
            }
            // remove the injected vue's input event
            // to prevent vue errors on the submit event
            delete on.input;
            return on;
        }
    },
    watch: {
        schema: {
            immediate: true,
            handler() {
                this.ready = false;
                this.initialModel = Objects.clone(this.value);
            }
        },
        options: {
            immediate: true,
            handler(options) {
                this.parser = Parser.get(options);
            }
        }
    },
    render(createElement) {
        if (this.parser === null || this.ready === false) {
            return null; // nothing to render
        }
        const attrs = {
            disabled: this.disabled
        };
        const props = {
            field: this.parser.field
        };
        const element = createElement(props.field.descriptor.component, { attrs, props });
        const nodes = [element];
        if (this.$slots.default) {
            nodes.push(...this.$slots.default);
        }
        return createElement(this.components.get('form'), {
            ref: this.ref,
            key: this.key,
            attrs: {
                id: this.id,
                name: this.name,
                role: this.search ? 'search' : undefined
            },
            props: props,
            on: this.listeners
        }, nodes);
    },
    methods: {
        /**
         * Get the HTML form object reference.
         *
         * **Example**
         *
         * ```html
         * <template>
         *   <FormSchema ref="formSchema" :schema="schema"/>
         * </template>
         *
         * <script>
         *   import FormSchema from '@formschema/native'
         *
         *   export default {
         *     components: { FormSchema },
         *     data: () => ({
         *       schema: { type: 'string' }
         *     }),
         *     mounted() {
         *       console.log(this.$refs.formSchema.form())
         *     }
         *   };
         * </script>
         * ```
         *
         * @returns {HTMLFormElement|VNode|undefined} - An `HTMLFormElement` object or a `VNode` object describing the form element object, or `undefined` for input JSON schema object.
         */
        form() {
            return this.$refs[this.ref];
        },
        /**
         * @private
         */
        emitInputEvent(value, field) {
            if (this.ready && this.validator) {
                this.validator(field).then((result) => {
                    if (result) {
                        this.ready = true;
                    }
                });
            }
            /**
             * Fired synchronously when the value of an element is changed.
             */
            this.$emit('input', value);
            this.$nextTick(() => {
                this.ready = true;
            });
        },
        /**
         * @private
         */
        update([field]) {
            this.key = field.key;
        }
    }
};

export default FormSchema;
export { Components, Fieldset, GLOBAL, NativeComponents, Objects, Parser, UIDescriptor, UniqueId, Field };
//# sourceMappingURL=FormSchema.esm.min.js.map



// WEBPACK FOOTER //
// ./src/FormSchema.esm.min.js